import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el))
})
